import { useQuery } from "@tanstack/react-query";
import { getEvents } from "../services/events-service";
import type {
	EventsListParams,
	EventsPaginatedResponse,
} from "../types/events";

export function useEventsList(params: EventsListParams) {
	return useQuery<EventsPaginatedResponse>({
		queryKey: ["tracking", "events", params],
		queryFn: () => getEvents(params),
		enabled: params.pageNumber >= 1 && params.pageSize >= 1,
	});
}
